import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

import { logError } from 'src/utils/dynatrace';
import { API_ERROR_MESSAGES } from 'src/utils/constants';

import { BACKEND_API, APPLICATION_ID } from 'src/global-config';

const axiosInstance = axios.create({
  baseURL: `${BACKEND_API.baseUrl}${BACKEND_API.prefix}`,
});

axiosInstance.interceptors.request.use(async (config) => {
  // Do not add headers for s3 buckets calls
  if (config.url?.includes('s3.amazonaws.com')) {
    return config;
  }

  const sessionId = localStorage.getItem('sessionId');
  const idToken = localStorage.getItem('idToken');

  config.headers.Authorization = `Bearer ${idToken}`;
  config.headers.correlationId = uuidv4();
  config.headers.application = APPLICATION_ID;

  if (sessionId) {
    config.headers['x-session-id'] = sessionId;
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => {
    const errorResponse = error.response;

    logError(error);
    // Handle 401 Unauthorized errors when idToken is expired earlier than expected
    // if (errorResponse && errorResponse.status === 401) {
    //   msalInstance.loginRedirect();
    //   return;
    // }

    // Handle errors from Gateway and backend service
    if (errorResponse.status === 503) {
      throw new Error(API_ERROR_MESSAGES.SERVICE_UNAVAILABLE);
    }

    throw new Error(errorResponse.data.error?.message || API_ERROR_MESSAGES.UNKNOWN_ERROR);
  }
);

export default axiosInstance;
